import { USER_PERMISSIONS } from '../../constants/userPermissions'
import type { RouteRecordRaw } from 'vue-router'

const staffRoutes: RouteRecordRaw[] = [
  {
    path: '/staff',
    name: 'staff',
    meta: {
      title: 'Admin',
      show_on_sidenav: true,
      is_expanded: false,
      must_authenticate: true,
      icon: 'lock-outline',
      permissions_needed: [
        USER_PERMISSIONS.CAN_MANAGE_AREAS,
        USER_PERMISSIONS.CAN_MANAGE_ROLES,
        USER_PERMISSIONS.CAN_MANAGE_LEVIES,
        USER_PERMISSIONS.HAS_ACTIVE_DEMOCRACY_PROCESS,
      ],
    },
    children: [
      {
        path: 'local-party',
        name: 'staff-local-party',
        meta: {
          title: 'Local Party',
          icon: 'map-marker-star-outline',
          show_on_sidenav: true,
          permissions_needed: [USER_PERMISSIONS.CAN_MANAGE_AREAS],
        },
        component: () =>
          import(
            /* webpackChunkName: "staff-local-party" */ '../../views/staff/StaffAreaPage.vue'
          ),
      },
      {
        path: 'roles',
        name: 'staff-roles',
        meta: {
          title: 'Roles',
          icon: 'account-group-outline',
          show_on_sidenav: true,
          permissions_needed: [USER_PERMISSIONS.CAN_MANAGE_ROLES],
        },
        component: () =>
          import(
            /* webpackChunkName: "staff-roles" */ '../../views/staff/StaffAreaRolesPage.vue'
          ),
      },
      {
        path: 'organisers',
        name: 'staff-organisers',
        meta: {
          title: 'Organiser Allocation',
          icon: 'account-network-outline',
          show_on_sidenav: true,
          permissions_needed: [USER_PERMISSIONS.CAN_MANAGE_ORGANISERS],
        },
        component: () =>
          import(
            /* webpackChunkName: "staff-organisers" */ '../../views/staff/StaffAreaOrganisersPage.vue'
          ),
      },
      {
        path: 'areas/:areaGssCode/roles/:roleId',
        name: 'staff-area-role',
        meta: {
          title: 'Area Role',
          icon: 'account-cog-outline',
          show_on_sidenav: false,
          permissions_needed: [USER_PERMISSIONS.CAN_MANAGE_ROLES],
        },
        component: () =>
          import(
            /* webpackChunkName: "staff-area-role" */ '../../views/staff/StaffAreaRoleDetailsPage.vue'
          ),
      },
      {
        path: 'groups',
        name: 'staff-groups',
        meta: {
          title: 'User Groups',
          icon: 'file-tree',
          show_on_sidenav: true,
          permissions_needed: [USER_PERMISSIONS.IS_PERMISSIONS_ADMIN],
          section: 'User Management',
        },
        component: () =>
          import(
            /* webpackChunkName: "staff-groups" */ '../../views/staff/StaffGroupsPage.vue'
          ),
      },
      {
        path: 'groups/:groupId',
        name: 'staff-group-details',
        meta: {
          title: 'User Group Details',
          icon: 'file-tree',
          show_on_sidenav: false,
          permissions_needed: [USER_PERMISSIONS.IS_PERMISSIONS_ADMIN],
        },
        component: () =>
          import(
            /* webpackChunkName: "staff-group-details" */ '../../views/staff/StaffGroupDetailsPage.vue'
          ),
      },
      {
        path: 'users/search',
        name: 'staff-person-search',
        meta: {
          title: 'User Search',
          icon: 'magnify-plus-outline',
          show_on_sidenav: true,
          permissions_needed: [USER_PERMISSIONS.CAN_MANAGE_ROLES],
          section: 'User Management',
        },
        component: () =>
          import(
            /* webpackChunkName: "staff-person-search" */ '../../views/staff/StaffPersonSearchPage.vue'
          ),
      },
      {
        path: 'users/:personGuid',
        name: 'staff-person-details',
        meta: {
          title: 'User Details',
          icon: 'magnify-plus-outline',
          show_on_sidenav: false,
          permissions_needed: [USER_PERMISSIONS.CAN_MANAGE_ROLES],
        },
        component: () =>
          import(
            /* webpackChunkName: "staff-person-details" */ '../../views/staff/StaffPersonDetailsPage.vue'
          ),
      },
      {
        path: 'councillor-levy',
        name: 'councillor-levy',
        meta: {
          title: 'Councillors',
          icon: 'account-cog-outline',
          show_on_sidenav: true,
          permissions_needed: [USER_PERMISSIONS.CAN_MANAGE_LEVIES],
        },
        component: () =>
          import(
            /* webpackChunkName: "councillor-levy" */ '../../views/staff/councillor-levy/CouncillorLevyPage.vue'
          ),
      },
      {
        path: 'democracy-process',
        name: 'staff-democracy-process',
        meta: {
          title: 'Party Democracy',
          show_on_sidenav: true,
          must_authenticate: true,
          permissions_needed: [USER_PERMISSIONS.HAS_ACTIVE_DEMOCRACY_PROCESS],
          icon: 'vote-outline',
        },
        component: () =>
          import(
            /* webpackChunkName: "staff-democracy-process" */ '../../views/staff/StaffDemocracyProcessPage.vue'
          ),
      },
    ],
  },
]

export default staffRoutes
